import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  Label,
  Modal,
} from "reactstrap"
import { useNavigate, Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import CustomTable from "../../Custom/TableWithRemotePagination"
import classnames from "classnames"
import * as Yup from "yup"
import { Field, FormikProvider, useFormik } from "formik"
import CustomSelect from "Custom/CustomSelect"
import { get, post, del } from "helpers/api_helper"
import { GET_CURRENCY_CON_LIST, POST_DELETE_CURRENCY } from "helpers/url_helper"
import { Spin } from "antd"
import swal from "sweetalert"
import SwalError from "Custom/SwalError"
import moment from "moment"

const CurrencyConversionList = props => {
  const navigate = useNavigate()
  const [totalSize, setTotalSize] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [currencyList, setCurrencyList] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10)

  const [showSwalError, setShowSwalError] = useState(false)
  const [swalErrorMsg, setSwalErrorMsg] = useState("")

  var Auth = JSON.parse(localStorage.getItem("authUser"))

  const columns = [
    {
      text: (
        <>
          <Input
            type="checkbox"
            className="form-check-input"
            id="Add"
            checked={false}
          />
          &nbsp; Date
        </>
      ),
      dataField: "Date",
      style: { minWidth: "150px" },
    },
    {
      text: "From Currency",
      dataField: "FromCurrency",
      style: { minWidth: "150px", },
    },
    {
      text: "To Currency",
      dataField: "ToCurrency",
      style: { minWidth: "150px", },
    },
    {
      text: "Value",
      dataField: "Value",
      style: { minWidth: "150px", },
    },
    {
      text: "Actions",
      dataField: "Actions",
      style: { maxWidth: "90px", minWidth: "70px" },
    },
  ]


  const getData = (page = 1, sizePerPage = 10) => {
    setIsLoading(true)
    get(
      GET_CURRENCY_CON_LIST +
      "?page=" +
      page +
      "&paginate=" +
      sizePerPage +
      (Search ? "&search=" + Search : "") +
      (SearchByColumn ? "&column_filter=" + SearchByColumn : "")
    )
      .then(res => {
        if (res?.data?.data?.length > 0) {
          setCurrencyList(
            res?.data?.data?.map((e, index) => {
              return {
                Date: (
                  <>
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      id="Add"
                      checked={false}
                    />{" "}
                    &nbsp;
                    {e.as_of_date
                      ? moment(e.as_of_date)
                        .format("DD-MMM-YYYY")
                        .replace(/^\-/, "")
                      : ""}
                  </>
                ),
                ToCurrency: e.to_currency.code,
                FromCurrency: e.from_currency.code,
                Value: (
                  <>Rs. {e.value ? parseFloat(e.value).toFixed(2) : "0.00"}</>
                ),
                Actions: (
                  <>
                    <div className="d-flex">

                      <Link
                        className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                        style={{
                          width: "25px",
                          height: "25px",
                          padding: "0px",
                        }}
                        to={`/edit-currency-conversion/${e.id}`}
                        title="Edit"
                      >
                        <i
                          className="fas fa-edit"
                          style={{ color: "#17a98c" }}
                        ></i>
                      </Link>
                      <Button
                        className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                        style={{
                          width: "25px",
                          height: "25px",
                          padding: "0px",
                        }}
                        title="Delete"
                        onClick={() => {
                          deleteCurrency(e.id)
                        }}
                      >
                        <i
                          className="fas fa-trash-alt"
                          style={{
                            color: "red",
                          }}
                        ></i>
                      </Button>
                    </div>
                  </>
                ),
              }
            })
          )
          setTotalSize(res?.data?.total)
          setIsLoading(false)
        } else {
          setCurrencyList([])
          setTotalSize(0)
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
    setCurrentPage(page)
    setCurrentSizePerPage(sizePerPage)
  }

  const validationSchemaFilter = Yup.object().shape({})

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Search: "",
      SearchByColumn: "",
    },
    validateOnBlur: false,
  })

  const {
    setFieldValue,
    values: { Search, SearchByColumn },
  } = formikFilter

  const handleValidSubmitFilter = values => { }

  useEffect(() => {
    getData()
  }, [Search, SearchByColumn])

  const currencyOptions = [
    { label: "Conversion Value", value: "value" },

  ]

  const deleteCurrency = ID => {
    swal({
      title: "Are you sure you want to delete the currency conversion?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(willDo => {
      if (willDo) {
        deleteCurrencyConfirm(ID)
      }
    })
  }

  const deleteCurrencyConfirm = async ID => {
    setIsLoading(true)
    await del(POST_DELETE_CURRENCY + "?id=" + ID)
      .then(response => {
        if (response?.status == 200) {
          swal({
            title: "Delete Currency conversion",
            text: response?.message,
            icon: "success",
            button: "OK",
          })
          getData(currentPage, currentSizePerPage)
          setIsLoading(false)
        } else {
          // swal("Error!", response?.message, "error")
          if (typeof response?.message == "string") {
            swal({
              title: "Error!",
              text: response.message,
              icon: "error",
              button: "OK",
            })
          } else {
            setSwalErrorMsg(response?.message)
            setShowSwalError(true)
          }
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }

  return (
    <>
      <React.Fragment>
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <div className="page-content">
            <MetaTags>
              <title>{"Currency Conversion"} | Katlax OMS</title>
            </MetaTags>

            <Container fluid>
              <>
                <Row className="mt-3">
                  <Col lg={6}>
                    <div className="mt-2" style={{ fontSize: "large" }}>
                      <b>Currency Conversion</b>
                    </div>
                  </Col>
                  <Col lg={6} style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        navigate("/add-currency-conversion")
                      }}
                    >
                      Add Currency Conversion
                    </button>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="col-12">
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row>
                          <Col lg={12}>
                            <Row>
                              <Col lg={3} sm={6} md={3}>
                                <div className="form-group has-search">
                                  <span className="fa fa-search form-control-feedback"></span>
                                  <Input
                                    type="text"
                                    name="Search"
                                    className="form-control"
                                    placeholder="Search"
                                    value={Search}
                                    onChange={e => {
                                      //setSearch(e.target.value)
                                      formikFilter.setFieldValue(
                                        "Search",
                                        e.target.value
                                      )
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg={2} sm={6} md={2}>
                                <Field
                                  name="SearchByColumn"
                                  placeholder={"By Column"}
                                  component={CustomSelect}
                                  options={currencyOptions}
                                />
                              </Col>
                              <Col
                                lg={2}
                                className="mt-1"
                                style={{ textAlign: "left" }}
                              >
                                <div
                                  onClick={() => {
                                    formikFilter.setFieldValue("Search", "")
                                    formikFilter.setFieldValue(
                                      "SearchByColumn",
                                      ""
                                    )
                                  }}
                                >
                                  <i
                                    className="mdi mdi-filter-remove"
                                    style={{
                                      fontSize: "20px",
                                      color: "#4a539f",
                                    }}
                                  ></i>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                    <Card>
                      <CardBody className="table-fixed">
                        <CustomTable
                          keyField="Currency"
                          columns={columns}
                          data={currencyList}
                          totalSize={totalSize}
                          getData={getData}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
              <SwalError
                showError={showSwalError}
                setShowError={setShowSwalError}
                ErrorMsg={swalErrorMsg}
              ></SwalError>
            </Container>
          </div>
        </Spin>
      </React.Fragment>
    </>
  )
}
CurrencyConversionList.propTypes = {
  t: PropTypes.any,
}

export default withRouter(withTranslation()(CurrencyConversionList))
